import { attachDialog, closeDialog } from '../../util/dialog_helpers.js';
import { addPageAction } from '../../util/new_relic.js';

const attachEventHandlers = (dialog: HTMLElement) => {
  dialog.addEventListener('click', (event) => {
    if ((event.target as HTMLElement).closest('[data-id="close-button"], [data-id="close-tips-button"]')) {
      closeDialog();
    }
  });
};

export const showVisualSearchTipsDialog = async () => {
  try {
    const { dialog, dialogPromise } = await attachDialog('visual_search_tips_dialog') as { dialog: HTMLElement, dialogPromise: Promise<void> };

    attachEventHandlers(dialog);
    addPageAction('typekit.render.visual-search.search-tips-modal');

    return dialogPromise;
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};
